import { createContext, useContext } from 'react';
import type { Transaction } from '@/types';
import type { SpaceExpense, SpaceSendRule } from '@/types/spaces';

export const SendToSpaceContext = createContext<{
  open: (transaction: Transaction) => void;
  openById: (transactionId: string, spaceId?: string) => Promise<void>;
  resolving: boolean;
  expenses: SpaceExpense[];
  rules: SpaceSendRule[];
} | null>(null);

export function useSendToSpace() {
  return useContext(SendToSpaceContext);
}
